import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import CommentIcon from '@material-ui/icons/ModeComment';

import {
  Label,
  Footer,
  IconStyle,
  PinnedPost,
  IconWrapper,
  VisuallyHidden,
} from './PinnedPostCard.styled';
import AddReaction from '../../../../../common/Icons/AddReaction';
import { ENTER } from '../../../../../../../utils/keyCodes';
import Banner from './Banner';
import PostContent from './PostContent';
import { analyticsTrackEvent } from '../../../../../../../../core/utils/analytics';
import { IMPORTANT_POST_VIEW_FROM_SIDEBAR } from '../../../../../../../../core/constants/analytics';

const PinnedPostCard = memo(
  ({
    user,
    time,
    postId,
    content,
    spaceId,
    reactionsCount,
    commentsCount,
    openPost,
  }) => {
    const [isFocused, setIsFocused] = useState(false);

    const handleClick = () => {
      analyticsTrackEvent(IMPORTANT_POST_VIEW_FROM_SIDEBAR, {
        activeClassroom: spaceId,
        postId,
      });
      openPost({ spaceId, postId });
    };

    const onFocus = () => setIsFocused(true);
    const onBlur = () => setIsFocused(false);

    return (
      <PinnedPost
        tabIndex={0}
        role="button"
        onClick={handleClick}
        onFocus={onFocus}
        onBlur={onBlur}
        onMouseEnter={onFocus}
        onMouseLeave={onBlur}
        onKeyDown={(e) => e.keyCode === ENTER && handleClick()}
      >
        <Banner user={user} time={time} />
        <PostContent content={content} />
        <Footer>
          <div>
            {commentsCount !== 0 && (
              <IconWrapper>
                <CommentIcon style={IconStyle} />
                <span className="count">{commentsCount}</span>
              </IconWrapper>
            )}
            {reactionsCount !== 0 && (
              <IconWrapper>
                <AddReaction style={IconStyle} />
                <span className="count">{reactionsCount}</span>
              </IconWrapper>
            )}
          </div>

          <Label css={!isFocused ? VisuallyHidden : ''}>Click to open</Label>
        </Footer>
      </PinnedPost>
    );
  }
);

PinnedPostCard.propTypes = {
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    avatar: PropTypes.string,
  }).isRequired,
  time: PropTypes.string.isRequired,
  postId: PropTypes.string.isRequired,
  spaceId: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  commentsCount: PropTypes.number.isRequired,
  reactionsCount: PropTypes.number.isRequired,
  openPost: PropTypes.func.isRequired,
};

export default PinnedPostCard;
